export default __webpack_public_path__ + "locales/pt-PT/translation.json";